/**
 * Product branding — SINGLE SOURCE OF TRUTH (Team S command, 2026-07-11).
 *
 * Test-pinned (claim-line pattern): every surface — web header, widget
 * "Powered by", PDF creator metadata, proposal footer, org-name fallbacks,
 * generated onboarding docs — reads the product name from HERE. Hardcoded
 * product-name strings anywhere else are a failing test.
 *
 * Renamed 2026-07-11: "PV Site Designer" → "PV Project Designer"
 * (branding only — no capability change; the E36 approved statements and
 * the E23c/E29 blocklist are untouched by design).
 */
export const PRODUCT_NAME = "PV Project Designer";

/** The retired name — exists ONLY so tests can assert its absence everywhere. */
export const RETIRED_PRODUCT_NAME = "PV Site Designer";
